import { mapSpacer } from 'src/siteBuilder/renderer/contentful/mapSpacer'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import { getLangFromContentfulLocale } from '@/utils/getLocaleFromContentfulLocale'
import { TypeVideoPickerWithoutUnresolvableLinksResponse } from 'contentful-types'
import { getYouTubeVideoIdFromUrl } from '../VideoYouTube/getYouTubeVideoIdFromUrl'
import videoPicker, { Video, VideoPickerProps } from './VideoPicker'

const ContentfulWebVideo = withContentful<TypeVideoPickerWithoutUnresolvableLinksResponse['fields'], VideoPickerProps>(
  videoPicker,
  {
    spacer: mapSpacer,
    selectedVideo: (props) => {
      if (props.fields?.selectedVideo && props.fields?.videoList) {
        const found = props.fields?.videoList[props.fields.selectedVideo - 1]?.fields?.videoId
        return !!found && getYouTubeVideoIdFromUrl(found)
      }
    },
    videoList: (props) => {
      const copy = getLangFromContentfulLocale(props)
      if (!props.fields.videoList) {
        return []
      }

      return props.fields?.videoList
        .filter((video) => video && video?.fields)
        .map((video): Video => {
          const {
            videoId,
            videoTitle,
            videoDescription,
            videoLength,
            aspectRatio,
            beginMuted,
            defaultVolume,
            posterSrc,
          } = video.fields

          return {
            videoId: getYouTubeVideoIdFromUrl(videoId),
            posterSrc: posterSrc?.fields?.file?.url,
            title: videoTitle,
            description: videoDescription,
            videoLength,
            aspectRatio,
            beginMuted: beginMuted || false,
            defaultVolume,
            copy,
          }
        })
    },
  }
)

export default ContentfulWebVideo
